/**
 * StatusBarItem model
 */

export class StatusBarItem {
    Name: string = "";
    Text: string = "";
    bVisible: boolean = true;
    width: number = 0;

    cloneForDiff(): { bVisible: boolean } {
        return {
            bVisible: this.bVisible,
        };
    }
}

export function SetupStatusBarData(GameData: any[]): StatusBarItem {
    const TheStatusBarItem = new StatusBarItem();
    TheStatusBarItem.Name = GameData[0];
    TheStatusBarItem.Text = GameData[1];
    TheStatusBarItem.bVisible = GameData[2];
    TheStatusBarItem.width = GameData[3];
    return TheStatusBarItem;
}
